const CheckoutForm = require('./form.js');
const CheckoutSteps = require('./steps.js');
const CheckoutOverview = require('./overview.js');
// require('./account.js')
const CheckoutCoupons = require('./coupons.js');

class Checkout {
  constructor() {
    this.form = new CheckoutForm();

    // TODO: Don't skip validation in production!
    // this.form.skipValidation = true;

    this.coupons = new CheckoutCoupons();
    this.steps = new CheckoutSteps();

    jQuery('.mad-checkout').on(
      'click', 
      '.mad-checkout-order-review .mad-checkout-order-review__item-remove', 
      this.removeFromCart);

    jQuery('.mad-checkout-steps__button.previous').click(function (e) {
      this.steps.previous();
      this.scrollToCheckoutTop();
    }.bind(this));

    jQuery('.mad-checkout-steps__button.next').click(function (e) {
      if (this.steps.validateCurrentStep()) {
        this.steps.next();
        this.scrollToCheckoutTop();
      } else {
        this.scrollToFirstInvalidInput();
      }
    }.bind(this));

    // this.coupons = new CheckoutCoupons();

    this.overview = new CheckoutOverview(this.steps);

    jQuery( document.body ).trigger( 'updated_checkout');
  }

  scrollToCheckoutTop() {
    // Calculate the offset position of .mad-checkout-form__container
    var formContainerOffset = jQuery('.mad-checkout').offset().top;

    // Animate the scroll to .mad-checkout-form__container
    jQuery('html, body').animate({
      scrollTop: formContainerOffset - 120
    }, 300);
  }

  scrollToFirstInvalidInput() {

    var firstInvalidInput = jQuery('.woocommerce-invalid').first();
    // Calculate the offset position of .mad-checkout-form__con tainer
    var inputOffset = firstInvalidInput.offset();

    if (inputOffset) {
      // Animate the scroll to .mad-checkout-form__container
      jQuery('html, body').animate({
        scrollTop: inputOffset.top - 120
      }, 300);
    } else {
      // console.log('Could not scroll to element!', firstInvalidInput);
    }
  }

  
  removeFromCart(e) {

    e.preventDefault();

    var button = jQuery(e.target).closest('.mad-checkout-order-review__item-remove > a')
    var item = button.closest('.mad-checkout-order-review__item')
    
    window.$madUtil.blockElement('.mad-checkout-order-review__container', {icon: {size: 'large'}})


    jQuery.ajax({
      type: 'POST',
      url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_from_cart'),
      data: {
        cart_item_key: button.data('cart_item_key')
      },
      success: function (response) {
        if ( ! response || ! response.fragments ) {
					window.location = button.attr( 'href' );
					return;
				}

        window.$madUtil.updateFragments(response.fragments);
        window.$madUtil.unblockElement('.mad-checkout-order-review__container')
      },
			error: function(response) {
        console.log('Error:', response)
				// window.location = button.attr( 'href' );
				// return;
        window.$madUtil.unblockElement('.mad-checkout-order-review__container')
			},
      dataType: 'json'
    });
  }
}

jQuery(document).ready(() => {
  if (!jQuery('.mad-checkout__container').length) return;

  require('./shipping.js')
  require('./payment.js')
  
  var checkout = new Checkout();
  window.$checkout = checkout;
})
